import clean from 'utility/cleanDigits';

/** client side credit card field validators */
export const creditCardValidators = {
	cardNumber: (value: string) => {
		const cardNumber = clean(value);
		if (!cardNumber) {
			return 'Please provide a card number';
		}
		if (cardNumber.length < 13) {
			return 'Card number is too short';
		}
		if (cardNumber.length > 16) {
			return 'Card number is too long';
		}
		return '';
	},

	expirationDate: (value: string) => {
		if (!value) {
			return 'Please provide an expiration date';
		}

		if (/^[0-9]{1,2}[/][0-9]{2,4}$/.test(value)) {
			return '';
		}

		return 'Please provide in format MM/YY';
	},

	cardCode: (value: string) => {
		if (!value) {
			return 'Please provide a security code';
		}

		if (/^[0-9]{3,4}$/.test(value)) {
			return '';
		}
		return 'Security code must be 3 or 4 digits';
	},
};

export default creditCardValidators;
